import dateMask from '@/lib/masks/date'
import phoneNumber from '@/lib/masks/phoneNumber'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

// import { Container } from './styles';

function Row({ manualCastration }) {
  return (
    <tr>
      <td>
        {manualCastration.animalName}
        <div>
          <small>
            {manualCastration?.animalCategory?.description} -
            &nbsp;{manualCastration?.animalBreed?.description}
          </small>
        </div>
      </td>
      <td>
        {manualCastration.fullName}
        <div>
          <small>{phoneNumber(manualCastration.phoneNumber)}</small>
        </div>
      </td>
      <td>{manualCastration?.microchip || '-'}</td>
      <td>{dateMask(manualCastration.castratedAt)}</td>
      <td className="text-right">
        <Link
          to={`/app/manual-castrations/show/${manualCastration?.id}`}
          className="btn btn-action btn-sm btn-primary"
        >
          <i className="fas fa-eye" />
        </Link>
      </td>
    </tr>
  )
}

Row.propTypes = {
  manualCastration: PropTypes.objectOf(Object).isRequired,
}

export default Row
